// Keep My Files implemented until it is ready to appear in the application.
export const MY_FILES_UI_ENABLED: boolean = false;
